<script>

    export let links = [];

</script>

{#if links.length > 0}
    <nav class="links">
        {#each links as link}
            {#if link.active && link.active !== 'false'}
                <a target="_blank" href={link.href} rel="noopener nofollow external" title={link.title}>
                    <i class="first">(</i>{link.title}<i>)</i>
                </a>
            {:else}
                <del>({link.title})</del>
            {/if}
        {/each}
    </nav>
{/if}

<style>

    .links {
        margin-top: 0.5rem;
        display: flex;
        gap: 0.5em;
    }

    a {
        white-space: nowrap;
    }
    a i {
        display: inline-block;
        transition: padding 300ms ease;
    }
    a:hover {
        text-decoration: underline;
        text-decoration-thickness: 1px;
    }
    a:hover i.first {
        padding-right: 0.2em;
    }
    a:hover i ~ i {
        padding-left: 0.2em;
    }

</style>